import {Component, EventEmitter, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HeaderService} from '../../core/services/header.service';
import {Title} from '@angular/platform-browser';
import {BaseComponent} from '../../core/base.component';
import {AuthService} from '../../core/security/auth.service';
import {RolesEnum} from '../../core/security/roles.enum';
import {CurrentUser} from '../../api/models/current-user';
import {ModulesEnum} from '../../core/security/modules.enum';
import {FilterOptionModel} from '../../dialogs/grid-filter/filter-option.model';
import {LookupModel} from '../../api/models/lookup-model';
import {AccountService} from '../account.service';
import { FlexModule } from '@angular/flex-layout';
import { GridFilterComponent } from '../../dialogs/grid-filter/grid-filter.component';
import { FilterRowAdditionalContentComponent } from '../../dialogs/grid-filter/filter-row-additional-content.component';
import { NgIf } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { UsersGridComponent } from './grid/users-grid.component';

@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        GridFilterComponent,
        FilterRowAdditionalContentComponent,
        NgIf,
        MatButton,
        MatTooltip,
        UsersGridComponent,
    ],
})
export class UsersComponent extends BaseComponent implements OnInit {

  detailsUrl: string;
  hasSoftPhoneModule: boolean;
  filterChangeEvent = new EventEmitter<any>();
  roles: LookupModel[] = [];
  filterOptions: FilterOptionModel[] = [];

  constructor(route: ActivatedRoute, headerService: HeaderService, titleService: Title, authService: AuthService,
              private accountService: AccountService,
              private router: Router) {
    super(route, headerService, titleService, authService);

    this.detailsUrl = '../user';

    this.editRoles = [RolesEnum.AccountUsers_Edit, RolesEnum.AccountUsers_Delete];
    this.deleteRoles = [RolesEnum.AccountUsers_Delete];
  }

  onCurrentUserChanged(user: CurrentUser): void {
    if (user) {
      this.hasSoftPhoneModule = user.modules.indexOf(ModulesEnum.SoftPhoneModule) > -1;
    } else {
      this.hasSoftPhoneModule = false;
    }
  }

  async ngOnInit() {
    await super.ngOnInit();

    this.accountService.queryRolesLookup().then(([roles, total]) => {
      this.roles = roles;

      this.initFilterOptions();
    });
  }

  onCreateNewUser() {
    this.router.navigate([this.detailsUrl, 'new', 'edit'], {relativeTo: this.route});
  }

  onFilterChanged(filter: any) {
    this.filterChangeEvent.emit(filter);
  }

  initFilterOptions(): void {
    this.filterOptions =  [
      {
        filterKey: 'searchText',
        multiValue: false,
        showAlways: true,
        type: 'string',
        title: 'Any'
      },
      {
        filterKey: 'username',
        multiValue: false,
        showAlways: true,
        title: 'Username',
        type: 'string',
      },
      {
        filterKey: 'firstName',
        multiValue: false,
        showAlways: true,
        title: 'First Name',
        type: 'string',
      },
      {
        filterKey: 'lastName',
        multiValue: false,
        showAlways: true,
        title: 'Last Name',
        type: 'string',
      },
      {
        filterKey: 'phoneNumber',
        multiValue: false,
        showAlways: true,
        title: 'Phone Number',
        type: 'phoneNumber',
      },
      {
        filterKey: 'extension',
        multiValue: false,
        showAlways: true,
        title: 'Extension',
        type: 'string',
      },
      {
        filterKey: 'isLocked',
        multiValue: false,
        showAlways: false,
        type: 'static',
        title: 'Locked?',
        displayValue: 'Yes',
        value: 'true',
        searchText: 'Locked: Yes',
      },
      {
        filterKey: 'isLocked',
        multiValue: false,
        showAlways: false,
        type: 'static',
        title: 'Locked?',
        displayValue: 'No',
        value: 'false',
        searchText: 'Locked: No',
      },
      {
        filterKey: 'isApproved',
        multiValue: false,
        showAlways: false,
        type: 'static',
        title: 'Approved?',
        displayValue: 'Yes',
        value: 'true',
        searchText: 'Approved: Yes',
      },
      {
        filterKey: 'isApproved',
        multiValue: false,
        showAlways: false,
        type: 'static',
        title: 'Approved?',
        displayValue: 'No',
        value: 'false',
        searchText: 'Approved: No',
      },
      {
        filterKey: 'isSoftPhoneActive',
        multiValue: false,
        showAlways: false,
        type: 'static',
        title: 'SoftPhone Active?',
        displayValue: 'Yes',
        value: 'true',
        searchText: 'SoftPhone Active: Yes',
      },
      {
        filterKey: 'isSoftPhoneActive',
        multiValue: false,
        showAlways: false,
        type: 'static',
        title: 'SoftPhone Active?',
        displayValue: 'No',
        value: 'false',
        searchText: 'SoftPhone Active: No',
      },
      {
        filterKey: 'isLdapEnabled',
        multiValue: false,
        showAlways: false,
        type: 'static',
        title: 'SoftPhone LDAP Active?',
        displayValue: 'Yes',
        value: 'true',
        searchText: 'SoftPhone LDAP Active: Yes',
      },
      {
        filterKey: 'isLdapEnabled',
        multiValue: false,
        showAlways: false,
        type: 'static',
        title: 'SoftPhone LDAP Active?',
        displayValue: 'No',
        value: 'false',
        searchText: 'SoftPhone LDAP Active: No',
      }
    ];

    if (this.roles?.length > 0) {
      for (const role of this.roles) {
        this.filterOptions.push({
          filterKey: 'roles',
          multiValue: true,
          showAlways: false,
          type: 'static',
          title: 'Role',
          displayValue: role.text,
          value: role.id,
          searchText: `Role: ${role.text}`,
        });
      }
    }
  }
}
